import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import '@mdi/font/css/materialdesignicons.min.css'
import 'flag-icons/css/flag-icons.min.css'

import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'
import dateFormatPlugin from './plugins/DateTimeFormat'
import disableNumberInputWheel from './plugins/disableNumberInputWheel'

const app = createApp(App)
app.use(router)
app.use(createPinia())
app.use(i18n)       
app.use(vuetify)
app.use(dateFormatPlugin)
app.use(disableNumberInputWheel)
app.mount('#app')
